import React from "react";
import { Link } from "react-router-dom";
import {
  FaCalendarAlt,
  FaUser,
  FaClock,
  FaChevronLeft,
  FaShare,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
  FaMoneyBillWave,
  FaCalculator,
  FaChartLine,
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DetailBlog9 = () => {
  const blogPost = {
    id: 6,
    title: "Rémunérations exceptionnelles au Bénin :le guide de votre Expert-Comptable",
    excerpt:
      "En tant que dirigeant de PME, vous savez que la reconnaissance du travail de vos collaborateurs passe souvent par des gratifications : 13ème mois, primes de départ, indemnités de fin de carrière... Maîtrisez le régime fiscal particulier pour éviter les redressements coûteux.",
    content: `
      <div class="hero-text-block">
        <p class="intro-paragraph">En tant que dirigeant de PME, vous savez que la reconnaissance du travail de vos collaborateurs passe souvent par des gratifications : 13ème mois, primes de départ, indemnités de fin de carrière... Ces paiements, bien que bénéfiques pour le climat social, obéissent à un régime fiscal particulier qui peut s'avérer complexe. Une erreur de calcul de l'Impôt sur les Traitements et Salaires (ITS) peut entraîner des redressements coûteux.</p>
        
        <div class="conviction-card">
          <div class="conviction-icon"></div>
          <p>Chez <strong>CINEF-EC</strong>, nous sommes convaincus qu'une bonne gestion passe par une parfaite compréhension des règles. C'est pourquoi nous vous proposons de décrypter ensemble le mode de calcul de l'impôt sur ces revenus, en nous basant sur l'article 126 du Code Général des Impôts (CGI) et la note circulaire N°1403 de la Direction Générale des Impôts.</p>
        </div>
      </div>

      <section class="content-section">
        <div class="section-header-styled">
          <span class="section-icon"></span>
          <h2>Qu'est-ce qu'une "Rémunération Exceptionnelle" pour le Fisc ?</h2>
        </div>

        <p class="section-text">L'administration fiscale définit très clairement ce qui entre dans cette catégorie. Selon l'article 126 du CGI, il s'agit de trois types de versements :</p>

        <div class="remuneration-types">
          <div class="type-card type-1">
            <div class="type-number">1</div>
            <h4>Indemnités de Fin de Carrière</h4>
            <p>Les indemnités de fin de carrière et les primes de départ volontaire.</p>
          </div>

          <div class="type-card type-2">
            <div class="type-number">2</div>
            <h4>Indemnités de Rupture</h4>
            <p>Les indemnités de préavis et de congés payés versées dans le cadre d'une rupture de contrat de travail.</p>
          </div>

          <div class="type-card type-3">
            <div class="type-number">3</div>
            <h4>Treizième Mois</h4>
            <p>Le treizième mois et toutes les rémunérations assimilées (primes de bilan, gratifications, etc.).</p>
          </div>
        </div>

        <div class="objective-banner">
          <h4> Objectif de ce régime</h4>
          <p>Éviter qu'un revenu versé en une seule fois ne soit lourdement taxé par l'application brute du barème progressif de l'impôt. La méthode vise donc à <strong>lisser l'imposition</strong>.</p>
        </div>
      </section>

      <section class="content-section calculation-section">
        <div class="section-header-styled">
          <span class="section-icon"></span>
          <h2>La Méthode de calcul expliquée simplement</h2>
        </div>

        <p class="section-text">La détermination de l'impôt sur ces revenus se fait en trois étapes logiques, comme précisé par la note circulaire.</p>

        <div class="steps-visual">
          <div class="step-visual">
            <div class="step-badge-visual">
              <span class="badge-text">ÉTAPE</span>
              <span class="badge-number">01</span>
            </div>
            <div class="step-content-visual">
              <h3>Calculer le Salaire mensuel Mmoyen</h3>
              <p>On détermine d'abord le salaire moyen des <strong>douze (12) derniers mois</strong> qui précèdent le versement de la prime. Ce salaire moyen inclut toutes les rémunérations versées durant cette période, y compris un éventuel 13ème mois de l'année précédente.</p>
              
              <div class="formula-box">
                <div class="formula-label">Formule :</div>
                <div class="formula-content">
                  Salaire Moyen = <span class="formula-highlight">(Total des salaires des 12 derniers mois) / 12</span>
                </div>
              </div>
            </div>
          </div>

          <div class="step-visual">
            <div class="step-badge-visual">
              <span class="badge-text">ÉTAPE</span>
              <span class="badge-number">02</span>
            </div>
            <div class="step-content-visual">
              <h3>Déterminer l'impôt moyen</h3>
              <p>On calcule ensuite l'ITS qui aurait été dû sur ce salaire mensuel moyen, en appliquant le barème progressif habituel. On obtient ainsi un <strong>impôt mensuel moyen</strong>.</p>
              
              <div class="bareme-card">
                <h4> Barème progressif mensuel de l'ITS</h4>
                <p class="bareme-subtitle">(Article 125 du CGI)</p>
                
                <div class="bareme-table">
                  <div class="bareme-row row-1">
                    <div class="bareme-tranche">0 à 60 000 FCFA</div>
                    <div class="bareme-taux">0%</div>
                  </div>
                  <div class="bareme-row row-2">
                    <div class="bareme-tranche">60 001 à 150 000 FCFA</div>
                    <div class="bareme-taux">10%</div>
                  </div>
                  <div class="bareme-row row-3">
                    <div class="bareme-tranche">150 001 à 250 000 FCFA</div>
                    <div class="bareme-taux">15%</div>
                  </div>
                  <div class="bareme-row row-4">
                    <div class="bareme-tranche">250 001 à 500 000 FCFA</div>
                    <div class="bareme-taux">19%</div>
                  </div>
                  <div class="bareme-row row-5">
                    <div class="bareme-tranche">Supérieur à 500 000 FCFA</div>
                    <div class="bareme-taux">30%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="step-visual">
            <div class="step-badge-visual">
              <span class="badge-text">ÉTAPE</span>
              <span class="badge-number">03</span>
            </div>
            <div class="step-content-visual">
              <h3>Appliquer la Formule de Prorata</h3>
              <p>C'est le <strong>cœur du calcul</strong>. L'impôt final pour le mois du versement est obtenu par la formule suivante :</p>
              
              <div class="formula-box main-formula">
                <div class="formula-label">Formule Principale :</div>
                <div class="formula-content">
                  ITS du mois = <span class="formula-highlight">Impôt Moyen × (Salaire normal du mois + Rémunération Exceptionnelle) / Salaire Moyen</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="content-section">
        <div class="alert-special">
          <div class="alert-icon-special"></div>
          <div class="alert-content-special">
            <h3>Attention au Cas Particulier : L'abattement sur les indemnités de départ</h3>
            <p>Il existe une règle spécifique et avantageuse pour certains types d'indemnités.</p>
            <div class="highlight-text">
              Pour le calcul de l'impôt sur les <strong>indemnités de fin de carrière</strong> et les <strong>primes de départ volontaire</strong>, un <strong>abattement de 25%</strong> est appliqué sur leur montant brut avant de les intégrer dans la formule.
            </div>
            <p class="conclusion-text">Concrètement, seulement <strong>75%</strong> de ces indemnités seront pris en compte pour le calcul de l'impôt.</p>
          </div>
        </div>
      </section>

      <section class="content-section example-section">
        <div class="section-header-styled">
          <span class="section-icon"></span>
          <h2>Mise en Pratique : Exemple d'un 13ème Mois</h2>
        </div>

        <p class="section-text">Pour illustrer, prenons le cas simple et fréquent d'un salarié qui touche un 13ème mois (inspiré de l'illustration 4 de la note circulaire).</p>

        <div class="example-container">
          <div class="situation-box">
            <h4> Situation</h4>
            <p>Un employé avec un <strong>salaire mensuel constant de 670 000 FCFA</strong>. En décembre, il reçoit son salaire de 670 000 FCFA + un 13ème mois de 670 000 FCFA.</p>
          </div>

          <div class="calculation-steps">
            <div class="calc-step">
              <div class="calc-step-header">
                <span class="calc-icon"></span>
                <h5>Étape 1 : Salaire Moyen</h5>
              </div>
              <p>Son salaire a été constant, le salaire moyen des 12 derniers mois est donc de <strong>670 000 FCFA</strong>.</p>
            </div>

            <div class="calc-step">
              <div class="calc-step-header">
                <span class="calc-icon"></span>
                <h5>Étape 2 : Impôt Moyen</h5>
              </div>
              <p>L'ITS calculé sur 670 000 FCFA est de <strong>122 500 FCFA</strong>. C'est notre impôt moyen.</p>
              
              <div class="detail-calcul">
                <h6>Détail du calcul :</h6>
                <ul class="calcul-list">
                  <li>
                    <span class="calcul-label">Tranche de 0 à 60 000 :</span>
                    <span class="calcul-value">60 000 × 0% = 0 FCFA</span>
                  </li>
                  <li>
                    <span class="calcul-label">Tranche de 60 001 à 150 000 (soit 90 000) :</span>
                    <span class="calcul-value">90 000 × 10% = 9 000 FCFA</span>
                  </li>
                  <li>
                    <span class="calcul-label">Tranche de 150 001 à 250 000 (soit 100 000) :</span>
                    <span class="calcul-value">100 000 × 15% = 15 000 FCFA</span>
                  </li>
                  <li>
                    <span class="calcul-label">Tranche de 250 001 à 500 000 (soit 250 000) :</span>
                    <span class="calcul-value">250 000 × 19% = 47 500 FCFA</span>
                  </li>
                  <li>
                    <span class="calcul-label">Tranche supérieure à 500 000 (170 000) :</span>
                    <span class="calcul-value">170 000 × 30% = 51 000 FCFA</span>
                  </li>
                </ul>
                <div class="total-calcul">
                  <strong>ITS moyen dû =</strong> 0 + 9 000 + 15 000 + 47 500 + 51 000 = <span class="total-value">122 500 FCFA</span>
                </div>
              </div>
            </div>

            <div class="calc-step">
              <div class="calc-step-header">
                <span class="calc-icon"></span>
                <h5>Étape 3 : Calcul Final</h5>
              </div>
              <ul class="final-list">
                <li><strong>Rémunérations totales de décembre :</strong> 670 000 (salaire) + 670 000 (13ème mois) = <strong>1 340 000 FCFA</strong></li>
                <li><strong>ITS de décembre :</strong> 122 500 × (1 340 000 / 670 000) = 122 500 × 2 = <strong class="result-highlight">245 000 FCFA</strong></li>
              </ul>
              
              <div class="conclusion-calc">
                <p> L'impôt du mois de décembre correspond donc logiquement au <strong>double de l'impôt moyen</strong>.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="content-section role-expert-section">
        <div class="section-header-styled centered">
          <span class="section-icon"></span>
          <h2>Le Rôle de votre Expert-Comptable : Anticiper pour Mieux Gérer</h2>
        </div>

        <p class="section-text centered-text">La gestion de la paie est une responsabilité majeure pour l'employeur. Le calcul de l'impôt sur les rémunérations exceptionnelles, par sa technicité, est une source d'erreurs fréquentes.</p>

        <div class="benefits-grid">
          <div class="benefit-card">
            <div class="benefit-icon">✓</div>
            <h4>La Conformité</h4>
            <p>Nous veillons à l'application stricte et correcte des textes en vigueur pour chaque bulletin de paie, vous mettant à l'abri de tout risque de redressement fiscal.</p>
          </div>

          <div class="benefit-card">
            <div class="benefit-icon">✓</div>
            <h4>L'Anticipation</h4>
            <p>Nous vous aidons à évaluer et à provisionner en amont le coût fiscal de vos politiques de gratification, pour une gestion de trésorerie sans surprise.</p>
          </div>

          <div class="benefit-card">
            <div class="benefit-icon">✓</div>
            <h4>Le Conseil</h4>
            <p>Nous vous conseillons sur les implications sociales et fiscales des différentes formes de rémunérations afin d'optimiser vos politiques salariales.</p>
          </div>
        </div>
      </section>

      <section class="content-section conclusion-section">
        <div class="conclusion-final">
          <h3>Conclusion</h3>
          <p>La méthode de calcul de l'impôt sur les revenus exceptionnels est certes spécifique, mais elle est logique et vise à assurer une juste imposition. La maîtriser est indispensable pour tout dirigeant soucieux de sa conformité et de la justesse de la paie versée à ses salariés.</p>
          <p class="cta-text">Pour sécuriser la gestion de paie de votre PME et vous concentrer sur votre cœur de métier, contactez votre expert-comptable, votre partenaire de confiance.</p>
        </div>
      </section>

      <div class="resources-final">
        <h4> Pour aller plus loin</h4>
        <ul>
          <li>L'intégralité de la Note circulaire N°1403</li>
          <li><a href="https://www.impots.bj/" target="_blank">Site de la Direction Générale des Impôts du Bénin</a></li>
          <li><a href="https://oeccabenin.bj/" target="_blank">Site de l'Ordre des Experts-comptables</a></li>
        </ul>
      </div>
    `,
    image: "/assets/images/remunerations-cover.jpg",
    categories: ["Paie", "Fiscalité", "Gestion Sociale"],
    tags: [
      "Paie",
      "ITS",
      "Primes",
      "Bonus",
      "Indemnités",
      "13èmeMois",
      "Conformité",
      "CGI",
      "ExpertComptable",
    ],
    date: "13 octobre 2025",
    author: "CINEF-EC",
    authorTitle: "Cabinet d'Expertise Comptable",
    readTime: "9 min",
    featured: true,
  };

  const similarBlogs = [
    {
      id: 1,
      title: "Gestion optimale de la paie pour PME au Bénin",
      image: "/assets/images/image1.png",
      date: "10 octobre 2025",
      category: "Paie",
    },
    {
      id: 3,
      title: "Les obligations sociales de l'employeur en 2025",
      image: "/assets/images/image8.png",
      date: "5 octobre 2025",
      category: "Gestion Sociale",
    },
  ];

  return (
    <>
      <Header />
      <div className="blog-layout">
        <div className="container">
          <nav className="breadcrumb-path">
            <Link to="/" className="path-item">Accueil</Link>
            <span className="path-sep">›</span>
            <Link to="/actualites/blog" className="path-item">Blog</Link>
            <span className="path-sep">›</span>
            <span className="path-current">Rémunérations Exceptionnelles</span>
          </nav>

          <div className="row">
            <div className="col-lg-8">
              <article className="blog-post-wrapper">
                <header className="post-header">
                  <div className="category-tags">
                    {blogPost.categories.map((category, index) => (
                      <span key={index} className="cat-tag">
                        {category}
                      </span>
                    ))}
                  </div>
                  
                  <h1 className="post-main-title">{blogPost.title}</h1>

                  <div className="post-metadata">
                    <div className="metadata-item">
                      <FaCalendarAlt className="metadata-icon" />
                      <span>{blogPost.date}</span>
                    </div>
                    <div className="metadata-item">
                      <FaUser className="metadata-icon" />
                      <span>{blogPost.author}</span>
                    </div>
                    <div className="metadata-item">
                      <FaClock className="metadata-icon" />
                      <span>{blogPost.readTime} de lecture</span>
                    </div>
                  </div>
                </header>

               

                <div className="post-excerpt">
                  <div class="excerpt-line"></div>
                  <p>{blogPost.excerpt}</p>
                </div>

                <div
                  className="post-content"
                  dangerouslySetInnerHTML={{ __html: blogPost.content }}
                />

                <footer className="post-footer">
                  <div className="footer-tags">
                    <span className="footer-tags-label">Mots-clés</span>
                    <div className="footer-tags-list">
                      {blogPost.tags.map((tag, index) => (
                        <Link key={index} to="#" className="footer-tag">
                          #{tag}
                        </Link>
                      ))}
                    </div>
                  </div>

                  <div className="footer-share">
                    <h5 className="footer-share-title">
                      <FaShare />
                      <span>Partager</span>
                    </h5>
                    <div className="footer-social">
                      <a href="#" className="social-link linkedin-link">
                        <FaLinkedin />
                      </a>
                      <a href="#" className="social-link twitter-link">
                        <FaTwitter />
                      </a>
                      <a href="#" className="social-link facebook-link">
                        <FaFacebook />
                      </a>
                    </div>
                  </div>

                  <div className="footer-nav">
                    <Link to="/actualites/blog" className="nav-back-btn">
                      <FaChevronLeft />
                      <span>Retour au blog</span>
                    </Link>
                  </div>
                </footer>
              </article>
            </div>

            <aside className="col-lg-4">
              <div className="sidebar-box author-box">
                <div className="box-header">
                  <FaUser className="box-icon" />
                  <h4>L'auteur</h4>
                </div>
                <div className="author-info-box">
                  <div className="author-picture">
                    <img
                      src="../assets/images/image5.png"
                      alt={blogPost.author}
                    />
                  </div>
                  <h5 className="author-fullname">{blogPost.author}</h5>
                  <p className="author-job">{blogPost.authorTitle}</p>
                  <p className="author-description">
                    Expert en gestion sociale et paie, spécialisé dans l'optimisation fiscale des rémunérations. Accompagnement des PME dans leur conformité sociale et fiscale au Bénin.
                  </p>
                </div>
              </div>

              <div className="sidebar-box related-box">
                <div className="box-header">
                  <FaChartLine className="box-icon" />
                  <h4>À lire aussi</h4>
                </div>
                <div className="related-articles">
                  {similarBlogs.map((blog) => (
                    <Link
                      key={blog.id}
                      to={`/blog/${blog.id}`}
                      className="related-item"
                    >
                      <div className="related-image">
                        <img src={blog.image} alt={blog.title} />
                        <span className="related-cat">{blog.category}</span>
                      </div>
                      <div className="related-content">
                        <h6 className="related-heading">{blog.title}</h6>
                        <div className="related-meta">
                          <FaCalendarAlt />
                          <span>{blog.date}</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>

              <div className="sidebar-box subscribe-box">
                <div className="box-header">
                  <FaCalculator className="box-icon" />
                  <h4>Newsletter Paie & Social</h4>
                </div>
                <p className="subscribe-info">
                  Recevez nos conseils pratiques sur la gestion de la paie, les nouveautés fiscales et les bonnes pratiques en matière sociale.
                </p>
                <form className="subscribe-form">
                  <input
                    type="email"
                    className="subscribe-input"
                    placeholder="Votre email"
                    required
                  />
                  <button type="submit" className="subscribe-button">
                    M'abonner
                  </button>
                </form>
              </div>

              <div className="sidebar-box links-box">
                <div className="box-header">
                  <FaMoneyBillWave className="box-icon" />
                  <h4>Ressources</h4>
                </div>
                <ul className="resource-links">
                  <li>
                    <a href="https://www.impots.bj/" target="_blank" rel="noopener noreferrer">
                      Direction Générale des Impôts
                      <span>→</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://oeccabenin.bj/" target="_blank" rel="noopener noreferrer">
                      Ordre des Experts-Comptables
                      <span>→</span>
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      Code Général des Impôts
                      <span>→</span>
                    </a>
                  </li>
                  <li>
                    <Link to="/services/comptabilite-fiscalite">
                      Nos Services Paie
                      <span>→</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </div>

      <style jsx>{`
        @import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=Montserrat:wght@400;500;600;700;800;900&display=swap");

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .blog-layout {
          background: linear-gradient(to bottom, #fafafa 0%, #fff 50%);
          padding: 3rem 0 5rem;
          font-family: "Inter", sans-serif;
          color: #2d3748;
        }
        .blog-layout * {
          margin-top: 0.5rem !important;
          margin-bottom: 0.5rem !important;
        }


        /* Breadcrumb */
        .breadcrumb-path {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 1rem 0 2.5rem;
          font-size: 0.9rem;
        }

        .path-item {
          color: #718096;
          text-decoration: none;
          font-weight: 500;
          transition: all 0.2s;
        }

        .path-item:hover {
          color: #198754;
        }

        .path-sep {
          color: #cbd5e1;
        }

        .path-current {
          color: #2d3748;
          font-weight: 600;
        }

        /* Post Wrapper */
        .blog-post-wrapper {
          background: white;
          border-radius: 24px;
          box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
        }

        .post-header {
          padding: 3rem 3rem 2.5rem;
          background: linear-gradient(135deg, #f7fafc 0%, #fff 100%);
        }

        .category-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 0.65rem;
          margin-bottom: 1.75rem;
        }

        .cat-tag {
          background: linear-gradient(135deg, #198754, #20c997);
          color: white;
          padding: 0.5rem 1.25rem;
          border-radius: 8px;
          font-size: 0.75rem;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          box-shadow: 0 2px 8px rgba(25, 135, 84, 0.25);
        }

        .post-main-title {
          font-family: "Montserrat", sans-serif;
          font-size: 3rem;
          font-weight: 900;
          line-height: 1.15;
          color: #1a202c;
          margin-bottom: 2rem;
        }

        .post-metadata {
          display: flex;
          flex-wrap: wrap;
          gap: 2rem;
          padding-top: 1.5rem;
          border-top: 2px solid #e2e8f0;
          
        }

        .metadata-item {
          display: flex;
          align-items: center;
          gap: 0.6rem;
          color: #718096;
          font-size: 0.95rem;
          font-weight: 600;
        }

        .metadata-icon {
          color: #198754;
          font-size: 1rem;
        }

        /* Featured Visual */
        .featured-visual {
          position: relative;
          width: 100%;
          height: 480px;
          overflow: hidden;
        }

        .visual-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .visual-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(25, 135, 84, 0.85), rgba(32, 201, 151, 0.75));
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.4s ease;
        }

        .featured-visual:hover .visual-overlay {
          opacity: 1;
        }

        .overlay-content {
          transform: scale(0.8);
          transition: transform 0.4s ease;
        }

        .featured-visual:hover .overlay-content {
          transform: scale(1);
        }

        .overlay-icon {
          font-size: 5rem;
          color: white;
        }

        /* Excerpt */
        .post-excerpt {
          padding: -1rem 1.5rem;
          background: white;
          position: relative;
          margin-top: -1rem ;
          margin-left: 3rem ;
          
        }

        .excerpt-line {
          width: 80px;
          height: 4px;
          background: linear-gradient(to right, #198754, #20c997);
          margin-bottom: 1.5rem;
          border-radius: 2px;
        }

        .post-excerpt p {
          font-size: 1.2rem;
          line-height: 1.75;
          color: #4a5568;
          font-weight: 500;
          margin: 0;
        }

        /* Content */
        .post-content {
          padding: 1rem;
          font-size: 1.05rem;
          line-height: 1.8;
          color: #4a5568;
          margin-left: 1.5rem
        }

        .hero-text-block {
          margin-bottom: 3rem;
        }

        .intro-paragraph {
          font-size: 1.15rem;
          line-height: 1.8;
          color: #2d3748;
          margin-bottom: 2rem;
        }

        .conviction-card {
          background: linear-gradient(135deg, #f0fdf4, #dcfce7);
          padding: 2rem;
          border-radius: 16px;
          border-left: 5px solid #198754;
          display: flex;
          gap: 1.5rem;
          align-items: flex-start;
          box-shadow: 0 4px 12px rgba(25, 135, 84, 0.1);
        }

        .conviction-icon {
          font-size: 2.5rem;
          flex-shrink: 0;
        }

        .conviction-card p {
          margin: 0;
          color: #1a202c;
          font-weight: 500;
          line-height: 1.7;
        }

        /* Sections */
        .content-section {
          margin: 3.5rem 0;
          padding : 1rem ;
        }

        .section-header-styled {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 2rem;
          padding-bottom: 1rem;
          border-bottom: 3px solid #e2e8f0;
        }

        .section-header-styled.centered {
          justify-content: center;
          text-align: center;
        }

        .section-icon {
          font-size: 2.5rem;
        }

        .section-header-styled h2 {
          font-family: "Montserrat", sans-serif;
          font-size: 2rem;
          font-weight: 800;
          color: #1a202c;
          margin: 0;
        }

        .section-text {
          font-size: 1.1rem;
          color: #4a5568;
          line-height: 1.7;
          margin-bottom: 2rem;
        }

        .centered-text {
          text-align: center;
        }

        /* Remuneration Types */
        .remuneration-types {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 1.5rem;
          margin: 2.5rem 0;
        }

        .type-card {
          background: white;
          padding: 2rem;
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          border: 3px solid;
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .type-card::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 6px;
          background: linear-gradient(to right, #198754, #20c997);
        }

        .type-1 {
          border-color: #e6f7ed;
        }

        .type-2 {
          border-color: #fef3c7;
        }

        .type-3 {
          border-color: #dbeafe;
        }

        .type-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
        }

        .type-number {
          width: 50px;
          height: 50px;
          background: linear-gradient(135deg, #198754, #20c997);
          color: white;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.8rem;
          font-weight: 900;
          margin-bottom: 1.5rem;
          box-shadow: 0 4px 12px rgba(25, 135, 84, 0.3);
        }

        .type-card h4 {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 0.75rem;
        }

        .type-card p {
          color: #4a5568;
          margin: 0;
          line-height: 1.6;
        }

        /* Objective Banner */
        .objective-banner {
          background: linear-gradient(135deg, #fff7ed, #fed7aa);
          padding: 2rem;
          border-radius: 16px;
          border: 2px solid #f59e0b;
          margin: 2.5rem 0;
        }

        .objective-banner h4 {
          font-size: 1.3rem;
          font-weight: 700;
          color: #92400e;
          margin-bottom: 1rem;
        }

        .objective-banner p {
          color: #78350f;
          margin: 0;
          font-size: 1.05rem;
          line-height: 1.7;
        }

        /* Steps Visual */
        .steps-visual {
          margin: 3rem 0;
        }

        .step-visual {
          display: flex;
          gap: 2rem;
          margin-bottom: 3rem;
          align-items: flex-start;
        }

        .step-badge-visual {
          flex-shrink: 0;
          width: 100px;
          height: 100px;
          background: linear-gradient(135deg, #198754, #20c997);
          border-radius: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: white;
          box-shadow: 0 8px 24px rgba(25, 135, 84, 0.3);
          transform: rotate(-5deg);
          transition: transform 0.3s ease;
        }

        .step-visual:hover .step-badge-visual {
          transform: rotate(0deg) scale(1.05);
        }

        .badge-text {
          font-size: 0.7rem;
          font-weight: 700;
          letter-spacing: 1px;
          opacity: 0.9;
        }

        .badge-number {
          font-size: 2.5rem;
          font-weight: 900;
          line-height: 1;
        }

        .step-content-visual {
          flex: 1;
          background: white;
          padding: 2rem;
          border-radius: 16px;
          box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
          border: 2px solid #f7fafc;
        }

        .step-content-visual h3 {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 1rem;
        }

        .step-content-visual p {
          color: #4a5568;
          line-height: 1.7;
          margin-bottom: 1.5rem;
        }

        /* Formula Box */
        .formula-box {
          background: linear-gradient(135deg, #f7fafc, #edf2f7);
          padding: 1.5rem;
          border-radius: 12px;
          border-left: 4px solid #198754;
          margin: 1.5rem 0;
        }

        .formula-box.main-formula {
          background: linear-gradient(135deg, #dcfce7, #f0fdf4);
          border-left-color: #20c997;
          border-left-width: 6px;
        }

        .formula-label {
          font-weight: 700;
          color: #2d3748;
          margin-bottom: 0.75rem;
          font-size: 0.95rem;
        }

        .formula-content {
          color: #1a202c;
          font-size: 1.05rem;
          line-height: 1.6;
        }

        .formula-highlight {
          background: linear-gradient(135deg, #198754, #20c997);
          color: white;
          padding: 0.25rem 0.75rem;
          border-radius: 6px;
          font-weight: 700;
          display: inline-block;
          margin: 0.25rem 0;
        }

        /* Bareme Card */
        .bareme-card {
          background: white;
          padding: 2rem;
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          border: 2px solid #e2e8f0;
          margin: 2rem 0;
        }

        .bareme-card h4 {
          font-size: 1.3rem;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 0.5rem;
        }

        .bareme-subtitle {
          color: #718096;
          font-size: 0.9rem;
          font-style: italic;
          margin-bottom: 1.5rem;
        }

        .bareme-table {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }

        .bareme-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem 1.5rem;
          border-radius: 10px;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .bareme-row:hover {
          transform: translateX(8px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .row-1 {
          background: linear-gradient(135deg, #f0fdf4, #dcfce7);
          border-left: 4px solid #22c55e;
        }

        .row-2 {
          background: linear-gradient(135deg, #ecfdf5, #d1fae5);
          border-left: 4px solid #10b981;
        }

        .row-3 {
          background: linear-gradient(135deg, #fef9c3, #fef08a);
          border-left: 4px solid #eab308;
        }

        .row-4 {
          background: linear-gradient(135deg, #fed7aa, #fdba74);
          border-left: 4px solid #f97316;
        }

        .row-5 {
          background: linear-gradient(135deg, #fecaca, #fca5a5);
          border-left: 4px solid #ef4444;
        }

        .bareme-tranche {
          color: #2d3748;
          font-size: 0.95rem;
        }

        .bareme-taux {
          background: white;
          color: #1a202c;
          padding: 0.4rem 1rem;
          border-radius: 20px;
          font-size: 1rem;
          font-weight: 800;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        /* Alert Special */
        .alert-special {
          background: linear-gradient(135deg, #fef3c7, #fde68a);
          padding: 2.5rem;
          border-radius: 16px;
          border: 3px solid #f59e0b;
          display: flex;
          gap: 2rem;
          margin: 3rem 0;
          box-shadow: 0 8px 24px rgba(245, 158, 11, 0.2);
        }

        .alert-icon-special {
          font-size: 3rem;
          flex-shrink: 0;
        }

        .alert-content-special h3 {
          font-size: 1.4rem;
          font-weight: 700;
          color: #92400e;
          margin-bottom: 1rem;
        }

        .alert-content-special p {
          color: #78350f;
          line-height: 1.7;
          margin-bottom: 1rem;
        }

        .highlight-text {
          background: white;
          padding: 1.25rem;
          border-radius: 12px;
          font-weight: 600;
          color: #1a202c;
          margin: 1.5rem 0;
          border-left: 4px solid #f59e0b;
        }

        .conclusion-text {
          font-weight: 600;
          color: #92400e;
          font-size: 1.1rem;
        }

        /* Example Section */
        .example-container {
          background: #f7fafc;
          padding: 2.5rem;
          border-radius: 20px;
          margin: 2rem 0;
        }

        .situation-box {
          background: linear-gradient(135deg, #dbeafe, #bfdbfe);
          padding: 2rem;
          border-radius: 16px;
          border-left: 5px solid #3b82f6;
          margin-bottom: 2.5rem;
        }

        .situation-box h4 {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1e40af;
          margin-bottom: 1rem;
        }

        .situation-box p {
          color: #1e3a8a;
          margin: 0;
          font-size: 1.05rem;
          line-height: 1.7;
        }

        /* Calculation Steps */
        .calculation-steps {
          display: flex;
          flex-direction: column;
          gap: 2rem;
        }

        .calc-step {
          background: white;
          padding: 2rem;
          border-radius: 16px;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
          border: 2px solid #e2e8f0;
        }

        .calc-step-header {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 2px solid #f7fafc;
        }

        .calc-icon {
          font-size: 2rem;
        }

        .calc-step-header h5 {
          font-size: 1.3rem;
          font-weight: 700;
          color: #1a202c;
          margin: 0;
        }

        .calc-step p {
          color: #4a5568;
          line-height: 1.7;
          margin-bottom: 1rem;
        }

        .detail-calcul {
          background: #f7fafc;
          padding: 1.5rem;
          border-radius: 12px;
          margin-top: 1.5rem;
        }

        .detail-calcul h6 {
          font-size: 1rem;
          font-weight: 700;
          color: #2d3748;
          margin-bottom: 1rem;
        }

        .calcul-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .calcul-list li {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.75rem;
          margin-bottom: 0.5rem;
          background: white;
          border-radius: 8px;
          border-left: 3px solid #198754;
        }

        .calcul-label {
          color: #4a5568;
          font-size: 0.95rem;
        }

        .calcul-value {
          font-weight: 700;
          color: #1a202c;
        }

        .total-calcul {
          margin-top: 1.5rem;
          padding: 1.25rem;
          background: linear-gradient(135deg, #dcfce7, #bbf7d0);
          border-radius: 12px;
          text-align: center;
          font-size: 1.1rem;
          border: 2px solid #198754;
        }

        .total-value {
          color: #15803d;
          font-size: 1.4rem;
          font-weight: 900;
        }

        .final-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .final-list li {
          padding: 1rem;
          margin-bottom: 1rem;
          background: #f7fafc;
          border-radius: 10px;
          border-left: 4px solid #198754;
        }

        .result-highlight {
          color: #15803d;
          font-size: 1.3rem;
          font-weight: 900;
        }

        .conclusion-calc {
          margin-top: 1.5rem;
          padding: 1.5rem;
          background: linear-gradient(135deg, #fff7ed, #ffedd5);
          border-radius: 12px;
          border-left: 4px solid #f59e0b;
        }

        .conclusion-calc p {
          margin: 0;
          color: #92400e;
          font-weight: 600;
        }

        /* Benefits Grid */
        .benefits-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 2rem;
          margin: 3rem 0;
        }

        .benefit-card {
          background: white;
          padding: 2.5rem;
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          border: 2px solid #e2e8f0;
          text-align: center;
          transition: all 0.3s ease;
        }

        .benefit-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 12px 40px rgba(25, 135, 84, 0.2);
          border-color: #198754;
        }

        .benefit-icon {
          width: 70px;
          height: 70px;
          background: linear-gradient(135deg, #198754, #20c997);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          font-weight: 900;
          margin: 0 auto 1.5rem;
          box-shadow: 0 8px 20px rgba(25, 135, 84, 0.3);
        }

        .benefit-card h4 {
          font-size: 1.3rem;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 1rem;
        }

        .benefit-card p {
          color: #4a5568;
          line-height: 1.7;
          margin: 0;
        }

        /* Conclusion Section */
        .conclusion-final {
          background: linear-gradient(135deg, #f0fdf4, #dcfce7);
          padding: 3rem;
          border-radius: 20px;
          border: 3px solid #198754;
          text-align: center;
          box-shadow: 0 8px 32px rgba(25, 135, 84, 0.2);
        }

        .conclusion-final h3 {
          font-size: 2rem;
          font-weight: 800;
          color: #15803d;
          margin-bottom: 1.5rem;
        }

        .conclusion-final p {
          font-size: 1.1rem;
          color: #166534;
          line-height: 1.8;
          margin-bottom: 1rem;
        }

        .cta-text {
          font-weight: 700;
          font-size: 1.2rem;
          color: #14532d;
        }

        /* Resources Final */
        .resources-final {
          background: #f7fafc;
          padding: 2rem;
          border-radius: 16px;
          margin-top: 2.5rem;
        }

        .resources-final h4 {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 1rem;
        }

        .resources-final ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .resources-final li {
          padding: 0.5rem 0;
          color: #4a5568;
        }

        .resources-final a {
          color: #198754;
          text-decoration: none;
          font-weight: 600;
          transition: color 0.2s;
        }

        .resources-final a:hover {
          color: #20c997;
        }

        /* Post Footer */
        .post-footer {
          padding: 3rem;
          background: #f7fafc;
          border-top: 3px solid #e2e8f0;
        }

        .footer-tags {
          margin-bottom: 3rem;
        }

        .footer-tags-label {
          font-weight: 700;
          color: #2d3748;
          font-size: 1rem;
          display: block;
          margin-bottom: 1.25rem;
        }

        .footer-tags-list {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
        }

        .footer-tag {
          background: white;
          color: #4a5568;
          padding: 0.6rem 1.25rem;
          border-radius: 10px;
          text-decoration: none;
          font-size: 0.9rem;
          font-weight: 600;
          border: 2px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .footer-tag:hover {
          background: linear-gradient(135deg, #198754, #20c997);
          color: white;
          border-color: #198754;
          transform: translateY(-3px);
          box-shadow: 0 4px 12px rgba(25, 135, 84, 0.3);
        }

        .footer-share {
          padding: 2.5rem 0;
          border-top: 2px solid #e2e8f0;
          border-bottom: 2px solid #e2e8f0;
          margin-bottom: 2.5rem;
        }

        .footer-share-title {
          font-size: 1.1rem;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 1.5rem;
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .footer-social {
          display: flex;
          gap: 1.25rem;
        }

        .social-link {
          width: 55px;
          height: 55px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          font-size: 1.5rem;
          transition: all 0.3s ease;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
        }

        .social-link:hover {
          transform: translateY(-6px) rotate(5deg);
          box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3);
        }

        .linkedin-link {
          background: linear-gradient(135deg, #0077b5, #005582);
        }

        .twitter-link {
          background: linear-gradient(135deg, #1da1f2, #0d8bd9);
        }

        .facebook-link {
          background: linear-gradient(135deg, #4267b2, #2d4373);
        }

        .footer-nav {
          text-align: center;
        }

        .nav-back-btn {
          display: inline-flex;
          align-items: center;
          gap: 1rem;
          background: white;
          color: #4a5568;
          padding: 1.25rem 2.5rem;
          border-radius: 50px;
          text-decoration: none;
          border: 3px solid #e2e8f0;
          font-weight: 700;
          font-size: 1.05rem;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .nav-back-btn:hover {
          background: linear-gradient(135deg, #198754, #20c997);
          color: white;
          border-color: #198754;
          transform: translateX(-10px);
          box-shadow: 0 8px 24px rgba(25, 135, 84, 0.3);
        }

        /* Sidebar */
        .sidebar-box {
          background: white;
          border-radius: 20px;
          padding: 2.5rem;
          margin-bottom: 2.5rem;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
          border: 2px solid #f7fafc;
        }

        .box-header {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 2rem;
          padding-bottom: 1.25rem;
          border-bottom: 3px solid #f7fafc;
        }

        .box-icon {
          color: #198754;
          font-size: 1.8rem;
        }

        .box-header h4 {
          font-size: 1.4rem;
          font-weight: 800;
          color: #1a202c;
          margin: 0;
        }

        .author-info-box {
          text-align: center;
        }

        .author-picture {
          width: 110px;
          height: 110px;
          border-radius: 50%;
          overflow: hidden;
          margin: 0 auto 1.5rem;
          border: 4px solid #f7fafc;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        }

        .author-picture img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .author-fullname {
          font-size: 1.3rem;
          font-weight: 800;
          color: #1a202c;
          margin-bottom: 0.5rem;
        }

        .author-job {
          font-size: 1rem;
          color: #198754;
          font-weight: 700;
          margin-bottom: 1.25rem;
        }

        .author-description {
          font-size: 0.95rem;
          color: #718096;
          line-height: 1.7;
        }

        .related-articles {
          display: flex;
          flex-direction: column;
          gap: 1.75rem;
        }

        .related-item {
          display: flex;
          gap: 1.25rem;
          text-decoration: none;
          color: inherit;
          background: #f7fafc;
          border-radius: 16px;
          overflow: hidden;
          transition: all 0.3s ease;
          border: 2px solid transparent;
        }

        .related-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
          border-color: #198754;
        }

        .related-image {
          width: 130px;
          height: 100px;
          flex-shrink: 0;
          position: relative;
        }

        .related-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .related-cat {
          position: absolute;
          top: 0.5rem;
          left: 0.5rem;
          background: linear-gradient(135deg, #198754, #20c997);
          color: white;
          padding: 0.3rem 0.9rem;
          border-radius: 20px;
          font-size: 0.7rem;
          font-weight: 800;
        }

        .related-content {
          padding: 1rem;
          display: flex;
            flex-direction: column;
            justify-content: center;
            flex: 1;
        }
        .related-title {
          font-size: 1rem;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 0.5rem;
        }
        .related-date {
            font-size: 0.85rem;
            color: #718096;
            font-weight: 600;
        }
        .useful-links ul {
            list-style: none;
            padding: 0;
            margin: 0;
        }
        .useful-links li {
            margin-bottom: 1rem;
        }
        .useful-links a {
            color: #198754;
            text-decoration: none;
            font-weight: 600;
            transition: color 0.2s;
        }
        .useful-links a:hover {
            color: #20c997;
        }
        `}</style>
    </>
  );
};
export default DetailBlog9;